<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="项目名称：" prop="project_name">
                <span>{{model.project_name}}</span>
            </el-form-item>
            <el-form-item label="设备类型：" prop="device_type">
                <span>{{ transEnu(model.device_type, "device_type") }}</span>
            </el-form-item>
            <el-form-item label="设备编号：" prop="device_code">
                <span>{{model.device_code}}</span>
            </el-form-item>
            <el-form-item label="通道编号：" prop="channel_no">
                <span>{{model.channel_no}}</span>
            </el-form-item>
            <el-form-item label="警告类型：" prop="alert_type">
                <span>{{ transEnu(model.alert_type, "alert_type") }}</span>
            </el-form-item>
            <el-form-item label="警告名称：" prop="alert_type_str">
                <span>{{model.alert_type_str}}</span>
            </el-form-item>
            <el-form-item label="所在位置：" prop="location">
                <span>{{model.location}}</span>
            </el-form-item>
            <el-form-item label="阈值：" prop="threshold">
                <span>{{model.threshold}}</span>
            </el-form-item>
            <el-form-item label="警告值：" prop="value">
                <span>{{model.value}}</span>
            </el-form-item>
            <el-form-item label="进浆流量：" prop="volume_in">
                <span>{{model.volume_in}}</span>
            </el-form-item>
            <el-form-item label="回浆流量：" prop="volume_leak">
                <span>{{model.volume_leak}}</span>
            </el-form-item>
            <el-form-item label="压力：" prop="pressure">
                <span>{{model.pressure}}</span>
            </el-form-item>
            <el-form-item label="密度：" prop="density">
                <span>{{model.density}}</span>
            </el-form-item>
            <el-form-item label="警告时间：" prop="datetime">
                <span>{{model.datetime}}</span>
            </el-form-item>
            <el-form-item label="告警用户：" prop="user_names">
                <span>{{model.user_names}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'alertLogInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                top_pid: '',
                project_name: '',
                device_type: '',
                device_code: '',
                channel_no: '',
                alert_type: '',
                alert_type_str: '',
                location: '',
                threshold: '',
                value: '',
                volume_in: '',
                volume_leak: '',
                pressure: '',
                density: '',
                datetime: '',
                user_names: '',
            },
            getObj:{
                url:'/api/admin/alertlog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['alert_type', 'device_type'],
        };
    },
    methods: {}
};
</script>